







import { Component, mixins, namespace } from 'nuxt-property-decorator'
import MixinGeneral from '~/assets/mixins/general'
import { IHeaderBanner } from '~/assets/interfaces/site'

const siteStore = namespace('site')

@Component({
  components: {
    ComponentHeaderBanner: () =>
      import('~/components/header/header-banner.vue'),
    ComponentHeaderVariant5: () =>
      import('~/components/header/variants/header-variant-5.vue'),
    ComponentHeaderVariant7: () =>
      import('~/components/header/variants/header-variant-7.vue'),
  },
})
export default class componentHeader extends mixins(MixinGeneral) {
  @siteStore.State('headerBanner') readonly headerBanner!: IHeaderBanner | null
  @siteStore.Getter('getLayoutHeaderNumber') readonly layoutHeaderNumber!: 5 | 7

  private get componentHeader() {
    return this.layoutHeaderNumber === 7
      ? 'component-header-variant7'
      : 'component-header-variant5'
  }
}
